<template>
    <div>

        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item active>Titles</b-breadcrumb-item>
        </b-breadcrumb>

        <div class="card">
            <div class="bg-dark card-header text-white">Titles</div>
            <div class="card-body">
                <!-- The collapsable filter options -->
                <AppFormCardCollapsable :display-footer="true" @submit.prevent="onFilterSubmit()" class="mb-3">
                    <template v-slot:header>Filter</template>
                    <template v-slot:body>
                        <div class="form-row">
                            <div class="col-md-4 col-sm-6 form-group">
                                <label>Code</label>
                                <input
                                        class="form-control"
                                        placeholder="Title Code"
                                        v-model="filterOptions.code"
                                />
                            </div>
                            <div class="col-md-4 col-sm-6 form-group">
                                <label>Description</label>
                                <input
                                        class="form-control"
                                        placeholder="Title Description"
                                        v-model="filterOptions.description"
                                />
                            </div>
                        </div>
                    </template>
                    <template v-slot:footer>
                        <button class="btn btn-primary" type="submit">Apply</button>
                    </template>
                </AppFormCardCollapsable>


                <BTable
                        :busy="isLoading"
                        :fields="tableFields"
                        :items="titles"
                        :responsive="true"
                        primary-key="code"
                        show-empty
                        striped
                        table-class="table-align-middle">


                    

                    <!-- Footer Pagination -->
                    <template v-slot:custom-foot>
                        <b-tr>
                            <b-td :colspan="tableFields.length">
                                <AppTablePagination
                                        :page.sync="filterOptions.page"
                                        :pageSize.sync="filterOptions.pageSize"
                                        :totalCount.sync="totalTitles"
                                        v-on:update:page="loadData()"
                                        v-on:update:pageSize="onFilterSubmit()"
                                ></AppTablePagination>
                            </b-td>
                        </b-tr>
                    </template>

                </BTable>
            </div>
        </div>

    </div>
</template>

<script>
    import AppFormCardCollapsable from "@/components/shared/AppFormCardCollapsable";
    import AppTablePagination from "@/components/shared/AppTablePagination";

    import FAMISDBTitlesService from "../../services/FAMISDBTitlesService";


    export default {
        components: {

            AppFormCardCollapsable,
            AppTablePagination,
        },
        data() {
            return {
                titles: [],
                totalTitles: 0,
                deletingRow: null,
                filterOptions: {
                    page: 1,
                    pageSize: 10,
                    code: null,
                    description: null
                },
                isLoading: false,
                tableFields: [
                    {
                        key: 'code', 
                        label: 'Code',
                        thStyle: 'width:150px'
                    },
                    {
                        key: 'description',
                        label: 'Description',
                    }
                ]
            }
        },
        filters: {

        },
        methods: {
            /**
             * @description Loads the data from the API with the filter options bound to the component
             */
            loadData() {
                const vm = this;
                vm.isLoading = true;

                FAMISDBTitlesService.getFAMISDBTitles(vm.filterOptions)
                    .then(response => {
                        vm.titles = response.data;
                        vm.totalTitles = response.totalCount;
                    })
                    .catch(() => {
                        vm.redirectToError()
                    })
                    .finally(() => {
                        vm.isLoading = false;
                    })
            },

            /**
             * @description Resets the page to the first page and reloads the data
             */
            onFilterSubmit() {
                this.filterOptions.page = 1;
                this.loadData();
            },

        },
        created() {
            this.loadData();
        }
    }
</script>

